import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: "導入にあたって初期費用はかかりますか？",
    answer: "初期費用は一切かかりません。月額料金のみでご利用いただけます。"
  },
  {
    question: "プランの変更は可能ですか？",
    answer: "はい、いつでもプランの変更が可能です。変更は翌月の請求から反映されます。"
  },
  {
    question: "店舗数に制限はありますか？",
    answer: "店舗数は無制限です。Googleアカウントを連携するだけで、Google Business Profileに登録されているすべての店舗を管理できます。"
  },
  {
    question: "Google口コミはどのように取得されますか？",
    answer: "Google Business Profile APIと連携して、公式APIから直接口コミデータを取得します。「口コミ同期」ボタンをクリックするだけで、最新の口コミを取得できます。"
  },
  {
    question: "AIが生成した返信文はどの程度カスタマイズできますか？",
    answer: "オーナー様の過去の返信パターンを学習し、口調や表現を模倣します。また、キーワードやフレーズの登録、定型文の作成も可能で、ビジネスの特性に合わせた返信文を生成できます。"
  },
  {
    question: "他の口コミサイト（食べログやホットペッパーなど）にも対応していますか？",
    answer: "現在はGoogle口コミに特化したサービスを提供しておりますが、今後他のプラットフォームにも対応予定です。"
  },
  {
    question: "契約期間の縛りはありますか？",
    answer: "最低契約期間はございません。月単位でのご契約となり、いつでも解約可能です。"
  }
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section bg-gray-50">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl font-semibold">よくある質問</h2>
          <p className="max-w-2xl mx-auto text-lg">
            サービスについてのご質問にお答えします
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-4">
              <button
                className={`w-full text-left p-6 flex items-center justify-between rounded-2xl transition-all duration-300 ${
                  openIndex === index 
                    ? 'bg-white shadow-apple' 
                    : 'bg-white hover:bg-gray-100'
                }`}
                onClick={() => toggleFAQ(index)}
              >
                <span className="font-medium text-lg">{faq.question}</span>
                {openIndex === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </button>
              
              {openIndex === index && (
                <div className="bg-white p-6 pt-0 rounded-b-2xl shadow-apple">
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <p className="mb-4">他にご質問がございましたら、お気軽にお問い合わせください。</p>
          <a href="#contact" className="btn btn-primary">お問い合わせ</a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;